








































import Vue from "vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import ApiService from "@/services/ApiService";
export default Vue.extend({
  name: "AutomationStatsModal",
  data() {
    return {
      title: "Stats",
      monthlyStats: [],
      dailyStats: [],
      weeklyStats: [],
      totals: { accepted: 0, delivered: 0, opened: 0, failed: 0, clicked: 0 },
      totals24h: {
        accepted: 0,
        delivered: 0,
        opened: 0,
        failed: 0,
        clicked: 0,
      },
      totalsChart: {
        dimensions: {
          name: "Months",
          data: [],
        },
        measures: [
          {
            name: "Accepted",
            data: [],
          },
          {
            name: "Delivered",
            data: [],
          },
          {
            name: "Opened",
            data: [],
          },
          {
            name: "Failed",
            data: [],
          },
          {
            name: "Clicked",
            data: [],
          },
        ],
      },
      totals24Chart: null,
      chartTitle: {
        text: "",
        subtext: "",
      },
    };
  },
  components: {
    HeaderComponent,
  },
  props: {
    id: String,
    contentType: String,
    name: String,
  },
  methods: {
    getEmptyChartObject() {
      return {
        dimensions: {
          name: "Months",
          data: [],
        },
        measures: [
          {
            name: "Accepted",
            data: [],
          },
          {
            name: "Delivered",
            data: [],
          },
          {
            name: "Opened",
            data: [],
          },
          {
            name: "Failed",
            data: [],
          },
          {
            name: "Clicked",
            data: [],
          },
        ],
      };
    },
  },
  mounted() {
    this.title = this.name + " - Stats";
    ApiService.automationsApi.getAutomationStats(this.id, "3m").then((resp) => {
      this.monthlyStats = resp.data.stats;
      const totals = {
        accepted: 0,
        delivered: 0,
        opened: 0,
        failed: 0,
        clicked: 0,
      };
      const chartObj = this.getEmptyChartObject();
      resp.data.stats.forEach((element) => {
        const splitDate = element.time.split(" ");
        chartObj.dimensions.data.push(splitDate[2]);

        const failed =
          element.failed.permanent.total + element.failed.temporary.total;

        chartObj.measures[0].data.push(element.accepted.total);
        chartObj.measures[1].data.push(element.delivered.total);
        chartObj.measures[2].data.push(element.opened.unique);
        chartObj.measures[3].data.push(failed);
        chartObj.measures[4].data.push(element.clicked.total);

        totals.accepted += element.accepted.total;
        totals.delivered += element.delivered.total;
        totals.clicked += element.clicked.total;
        totals.opened += element.opened.unique ? element.opened.unique : 0;
        totals.failed += failed;
      });
      this.totalsChart = chartObj;
      this.totals = totals;
    });
    ApiService.automationsApi
      .getAutomationStats(this.id, "24h")
      .then((resp) => {
        this.dailyStats = resp.data.stats;
        const totals = {
          accepted: 0,
          delivered: 0,
          opened: 0,
          failed: 0,
          clicked: 0,
        };
        const chartObj = this.getEmptyChartObject();
        resp.data.stats.forEach((element) => {
          const splitDate = element.time.split(" ");
          chartObj.dimensions.data.push(splitDate[4]);

          const failed =
            element.failed.permanent.total + element.failed.temporary.total;

          chartObj.measures[0].data.push(element.accepted.total);
          chartObj.measures[1].data.push(element.delivered.total);
          chartObj.measures[2].data.push(element.opened.unique);
          chartObj.measures[3].data.push(failed);
          chartObj.measures[4].data.push(element.clicked.total);

          totals.accepted += element.accepted.total;
          totals.delivered += element.delivered.total;
          totals.clicked += element.clicked.total;
          totals.opened += element.opened.unique ? element.opened.unique : 0;
          totals.failed += failed;
        });
        this.totals24Chart = chartObj;
        this.totals24h = totals;
      });
  },
});
